/**
 * The response from the API does not contain the full metadata returned by the
 * GET conversation metadata request. Normalize it here to match
 * @param {Object} payload - The POST request API response from creating a conversation
 */
export const normalizeConversationOnCreate = payload => {
  return {
    createdAt: new Date().getTime(), // possible mismatch with actual data
    custom: {},
    conversation_id: payload.conversation_id,
    participants: {},
    subject: null,
    topicID: null,
  };
};
